import { render, staticRenderFns } from "./HeadProjectedTaxable.vue?vue&type=template&id=ec37eba8"
import script from "./HeadProjectedTaxable.vue?vue&type=script&lang=js"
export * from "./HeadProjectedTaxable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports